import React, { ReactNode } from 'react';
import menuItemStyles from './MenuItem.module.scss';
import { MenuItem as MenuItemMui } from '@mui/material';

type MenuItemProps = {
  children: ReactNode;
  onClick: (e: any) => void;
  disabled?: boolean;
  style?: React.CSSProperties;
  className?: string;
};

export const MenuItem = ({
  children,
  onClick,
  disabled,
  style,
  className,
}: MenuItemProps) => {
  return (
    <MenuItemMui
      onClick={onClick}
      className={className ?? menuItemStyles.menuItem}
      style={style}
      disabled={disabled}
    >
      {children}
    </MenuItemMui>
  );
};

export default MenuItem;
